const _ = require('./enum');

const paymentMethodTypes = {
  [_.BANK_TRANSFER]: {
    id: _.BANK_TRANSFER,
    label: 'Bank transfer',
  },
  [_.CARD]: {
    id: _.CARD,
    label: 'Card',
  },
  [_.CASH]: {
    id: _.CASH,
    label: 'Cash',
  },
  [_.E_WALLET]: {
    id: _.E_WALLET,
    label: 'E-wallet',
  },
  [_.INSTALMENTS]: {
    id: _.INSTALMENTS,
    label: 'Instalments',
  },
  [_.INSTANT_PAYMENT]: {
    id: _.INSTANT_PAYMENT,
    label: 'Instant payment',
  },
  [_.ON_REFERENCE]: {
    id: _.ON_REFERENCE,
    label: 'On reference',
  },
  [_.OPEN_INVOICE]: {
    id: _.OPEN_INVOICE,
    label: 'Open invoice',
  },
};

module.exports = paymentMethodTypes;
